import { useNavigate } from "@tanstack/react-router";

import { KickstarterBannerWrapper } from "./KickstarterBannerWrapper";

/**
 * Banner para a página de requests
 */
export function RequestsKickstarterBanner() {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="Some features are limited in this plan. Upgrade to unlock the full platform experience and get your requests processed by our team."
      primaryButtonOnClick={() => navigate({ to: "/pricing" })}
      primaryButtonText="Find my plan"
      secondaryButtonOnClick={() => navigate({ to: "/kickstarter-call" })}
      secondaryButtonText="Learn more"
      title="You're using a Kickstarter account"
    />
  );
}

/**
 * Banner para a página de create draft request
 */
export function CreateDraftKickstarterBanner() {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="This request is just an example with pre-filled content. You can edit it freely, duplicate it, or start a new request."
      primaryButtonOnClick={() => navigate({ to: "/pricing" })}
      primaryButtonText="New Request"
      secondaryButtonOnClick={() => {
        window.location.replace("https://meetings.hubspot.com/nolimit/sales");
      }}
      secondaryButtonText="Duplicate"
      title="This is a template request"
    />
  );
}

/**
 * Banner para a página de template request
 */
export function RequestTemplateKickstarterBanner({
  createDraft,
}: {
  createDraft: () => void;
}) {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="This request is just an example to show you how a design journey can look. Feel free to edit, duplicate, or create your own."
      primaryButtonOnClick={() => navigate({ to: "/requests/pick-type" })}
      primaryButtonText="New Request"
      secondaryButtonOnClick={createDraft}
      secondaryButtonText="Duplicate"
      title="This is a template request"
    />
  );
}

/**
 * Banner para a página de My Files
 */
export function MyFilesKickstarterBanner() {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="This request is just an example to show you how a design journey can look. Feel free to edit, duplicate, or create your own."
      primaryButtonOnClick={() => navigate({ to: "/requests/pick-type" })}
      primaryButtonText="New Request"
      secondaryButtonOnClick={() => {
        window.location.replace("https://meetings.hubspot.com/nolimit/sales");
      }}
      secondaryButtonText="Duplicate"
      title="This is a template request"
    />
  );
}

/**
 * Banner para a página de Brands
 */
export function BrandsKickstarterBanner() {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="Some features are limited in this plan. Upgrade to unlock the full platform experience and get your requests processed by our team"
      primaryButtonOnClick={() => navigate({ to: "/pricing" })}
      primaryButtonText="Find my plan"
      secondaryButtonOnClick={() => navigate({ to: "/kickstarter-call" })}
      secondaryButtonText="Learn more"
      title="You're using a Kickstarter account"
    />
  );
}

export function UsersKickstarterBanner() {
  const navigate = useNavigate();

  return (
    <KickstarterBannerWrapper
      description="Some features are limited in this plan. Upgrade to unlock the full platform experience and get your requests processed by our team "
      primaryButtonOnClick={() => navigate({ to: "/pricing" })}
      primaryButtonText="Find my plan"
      secondaryButtonOnClick={() => navigate({ to: "/kickstarter-call" })}
      secondaryButtonText="Learn more"
      title="You're using a Kickstarter account"
    />
  );
}
